export const comparisonPlatforms = [
  {
    name: "Kakobuy Spreadsheet",
    description: "Największa i najbardziej aktualna baza produktów dla polskich kupujących. Oferuje setki zweryfikowanych linków, szczegółowe recenzje i aktywną społeczność.",
    features: ["Największa baza produktów", "Regularne aktualizacje co tydzień", "Polska społeczność", "Szczegółowe recenzje", "Bezpłatny dostęp"],
    rating: 5,
  },
  {
    name: "CSSBuy Spreadsheet",
    description: "Alternatywny arkusz z dobrą selekcją produktów streetwear i sneakers. Mniejsza baza, ale z ciekawymi znaleziskami niedostępnymi gdzie indziej.",
    features: ["Dobra selekcja streetwear", "Unikalne znaleziska", "Prosty interfejs", "Mniejsza społeczność", "Podstawowe recenzje"],
    rating: 4,
  },
  {
    name: "Superbuy Spreadsheet",
    description: "Popularny arkusz z szeroką gamą kategorii produktowych. Szczególnie silny w kategorii elektroniki i gadżetów z chińskich marketplace.",
    features: ["Szeroki wybór kategorii", "Silna sekcja elektroniki", "Międzynarodowa społeczność", "Dobre porównania cen", "Średnia częstotliwość aktualizacji"],
    rating: 4,
  },
  {
    name: "Oopbuy Spreadsheet",
    description: "Nowy gracz na rynku z innowacyjnym podejściem do kategoryzacji produktów. Oferuje świeże spojrzenie i ciekawe znaleziska z mniej popularnych kategorii.",
    features: ["Innowacyjna kategoryzacja", "Świeże znaleziska", "Niszowe kategorie", "Rosnąca społeczność", "Nowoczesny interfejs"],
    rating: 3,
  },
];